export default function authHeader(token?: string) {
    // Use the passed token if available
    if (token) {
        return { Authorization: `Bearer ${token}` };
    }

    // If no token is passed, check local storage for persisted token
    const persistedStateJSON = localStorage.getItem('persist:root');
    const persistedState = JSON.parse(persistedStateJSON as string); // Add type assertion

    // Access the 'auth' reducer state
    const auth = JSON.parse(persistedState?.auth || '{}');

    if (auth.user && auth.token) {
        return { Authorization: `Bearer ${auth.token}` };
    } else {
        return {};
    }
}
